import React from "react";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import EntityDetailTopBar from "@common/components/entityDetailTopBar/EntityDetailTopBar";
import { useTranslation } from "@localization/useTranslation";
import { useUrlProvider } from "../../useUrlProvider";
import InternalAssessmentGroupTopBarRow from "../internalAssessmentGroupTopBar/InternalAssessmentGroupTopBarRow";
import InternalAssessmentGroupHeader from "../internalAssessmentGroupHeader/InternalAssessmentGroupHeader";
import useInternalAssessmentGroupDraftOverview from "./InternalAssessmentGroupDraftOverview.hooks";
import InternalAssessmentGroupAssigneeSelector from "./assigneeSelector/InternalAssessmentGroupAssigneeSelector";

function InternalAssessmentGroupDraftOverview() {
    const { translateString } = useTranslation();
    const { getInternalAssessmentGroupsUrl, getInternalAssessmentGroupUrl } = useUrlProvider();

    const { id, data, isLoading, refetch, updateSelectedAssignees } = useInternalAssessmentGroupDraftOverview();

    const getBreadCrumbs = () => {
        const breadCrumbs: Array<DotLegalBreadCrumbModel> = [];

        breadCrumbs.push({ name: translateString("internalAssessments"), link: getInternalAssessmentGroupsUrl() });
        breadCrumbs.push({ name: data?.name, link: data?.sent ? getInternalAssessmentGroupUrl(id!) : undefined });

        if (data && data.sent) {
            breadCrumbs.push({ name: translateString("addRecipients") });
        }

        return breadCrumbs;
    };

    return (
        <React.Fragment>
            <InternalAssessmentGroupHeader
                breadCrumbs={getBreadCrumbs()}
                internalAssessmentGroup={data}
                showAddRecipientsMenuItem={false}
                showDeleteMenuItem={!data?.sent}
                canBeDeleted
                onInternalAssessmentGroupUpdated={() => refetch()}
            />

            <Box sx={{ marginBottom: 2 }}>
                <EntityDetailTopBar>
                    <InternalAssessmentGroupTopBarRow
                        data={data}
                        isLoading={isLoading}
                        status={data?.sent ? translateString("inProgress") : translateString("draft")}
                    />
                </EntityDetailTopBar>
            </Box>

            <InternalAssessmentGroupAssigneeSelector
                internalAssessmentGroupId={id!}
                internalAssessmentGroupName={data?.name ?? ""}
                rows={data?.rows ?? []}
                selectedAssignees={data?.selectedAssignees ?? []}
                isAddingToSentGroup={!!data?.sent}
                isDeadlineOverdue={data?.isDeadlineOverdue ?? false}
                isLoading={isLoading}
                onSelectedAssigneesChange={updateSelectedAssignees}
                onRecipientAdded={refetch}
            />
        </React.Fragment>
    );
}

export default InternalAssessmentGroupDraftOverview;
